import react, { createContext, useEffect, useState } from 'react'
import { Button, Card, CardContent } from '@mui/material'
import './meetings.scss'
import Calender from './calender/calender'
import EventList from './eventsList/eventList';
import NewEventModal from './newMeetingModal/newMeetingModal';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { getEvents } from '../../../store/adminActions';

const Meetings = () => {
    const events = useAppSelector((state: any) => state.admin.events)
    const dispatch = useAppDispatch()
    const fetchEventList = async () => {
        await dispatch(getEvents("TM"))
    }
    useEffect(() => {
        fetchEventList()
    }, [])
    return (
        <div className='pt-4 px-4 w-100'>
            <div className='flex justify-content-between'>
                <h1 className="title_Student">Meetings</h1>
                <NewEventModal></NewEventModal>
            </div>
            <div className='outerContainer'>
                <Card className='cardContainer w-100'>
                    <CardContent className='w-100'>
                        <Calender events={events}></Calender>
                    </CardContent>
                </Card>
                <div>
                    <EventList events={events}></EventList>
                </div>

            </div>
        </div>
    )

}
export default Meetings